import api from "../../api";
export default {
  namespaced: true,
  state: {
    menuData: [],
  },
  getters: {
    getmenuData(state) {
      return state.menuData;
    },
  },
  mutations: {
    SetmenuData(state, data) {
      state.menuData = [];
      state.menuData = data;
    },
  },
  actions: {
    fetchmenuData({ commit }, content) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `/menu/get_menu`,
            {},
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            if (res.status == 200) {
              commit("SetmenuData", res.data.data);
              if (Array.isArray(res.data.data)) {
                const allowedPages = res.data.data
                  .map((item) => item.name)
                  .filter(Boolean);
                localStorage.setItem(
                  "allowedPages",
                  JSON.stringify(allowedPages)
                );
              }
              resolve(res);
            } else {
              resolve(res);
            }
          });
      });
    },
  },
};
